import { useEffect, useRef, useState } from 'react';
import { Button } from '../ui/Button';

export function InviteModal({
  url,
  expiresAt,
  warnReinvite,
  onClose,
}: {
  url: string;
  expiresAt: string;
  warnReinvite: boolean;
  onClose: () => void;
}) {
  const [copied, setCopied] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    // выделяем ссылку при открытии, чтобы можно было сразу Ctrl+C
    inputRef.current?.select();
  }, []);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  async function copy() {
    const text = window.location.origin + url;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      inputRef.current?.select();
      document.execCommand('copy');
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    }
  }

  const expires = new Date(expiresAt).toLocaleDateString('ru', {
    day: 'numeric',
    month: 'long',
  });
  const fullUrl = window.location.origin + url;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[480px] rounded border border-border bg-bg p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          className="font-display text-[26px] leading-none font-medium mb-1"
          style={{ fontVariationSettings: '"opsz" 48, "SOFT" 10' }}
        >
          {warnReinvite ? 'Ссылка для смены пароля' : 'Ссылка-приглашение'}
        </h2>
        <p className="text-[12px] text-muted mb-4">
          {warnReinvite
            ? `Скопируйте и перешлите ученику — он задаст новый пароль. Действует до ${expires}. Ссылка одноразовая.`
            : `Скопируйте и перешлите ученику. Действует до ${expires}. Ссылка одноразовая.`}
        </p>

        {warnReinvite ? (
          <p className="text-[12px] text-muted border border-border bg-panel px-3 py-2 rounded mb-4">
            Учётка и все задания сохранятся. Активные сессии ученика на других
            устройствах выйдут.
          </p>
        ) : null}

        <div className="flex gap-2 mb-4">
          <input
            ref={inputRef}
            readOnly
            value={fullUrl}
            className="flex-1 h-9 rounded border border-border bg-panel px-3 text-[12px] font-mono text-fg focus-visible:outline-none focus-visible:border-accent"
          />
          <Button onClick={copy} className="h-9">
            {copied ? 'Скопировано' : 'Скопировать'}
          </Button>
        </div>

        <div className="flex justify-end">
          <Button variant="ghost" onClick={onClose}>
            Закрыть
          </Button>
        </div>
      </div>
    </div>
  );
}
